import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@repo/ui/components/form';
import { Input } from '@repo/ui/components/input';
import { useFormContext } from 'react-hook-form';

import { fieldLabel, fieldSurface } from '../auth/AuthFrame';

/**
 * What a scanner reads off the pack (#319). Optional: most of the park's goods
 * carry none and never will.
 *
 * Shared by the create and edit forms, which both hold it as text and judge it
 * by `optionalBarcodeSchema` and send it through `barcodeOnTheWire`, so blank
 * goes to the API as `null`.
 */
export function BarcodeField() {
  const { control } = useFormContext<{ barcode: string }>();

  return (
    <FormField
      control={control}
      name="barcode"
      render={({ field }) => (
        <FormItem>
          <FormLabel className={fieldLabel}>Barcode</FormLabel>
          <FormControl
            render={
              <Input
                className={`${fieldSurface} h-11 font-mono numeric`}
                inputMode="numeric"
                placeholder="8901725016296"
                autoComplete="off"
                {...field}
              />
            }
          />
          <FormDescription>
            The digits under the bars, as a till&rsquo;s scanner reads them. Leave it blank if the
            item has none.
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
